import React from 'react';

import { IPostCard } from '../Card';

import style from './PostStats.scss';

import { readingTime } from '@tryghost/helpers';
import { formatPublishedAtDate } from 'utils/helpers';

interface IProps {
  publishedAt: string;
  author: string;
  post?: IPostCard;
  isReadingTimeShown?: boolean;
}

export const PostStats: React.FC<IProps> = ({ publishedAt, author, post, isReadingTimeShown }) => {
  return (
    <p className={style.wrapper}>
      {publishedAt ? (
        <>
          <span>{formatPublishedAtDate(publishedAt)}</span>
          <span className={style.dot}>&#183;</span>
        </>
      ) : null}
      {isReadingTimeShown ? readingTime(post) : <span className={style.author}>{author}</span>}
    </p>
  );
};

export default PostStats;
